import React, { Component } from "react";
import TMVoucherPDFViewer from "./TMVoucherPDFViewer.Component";
import { connect } from "react-redux";
import { Constants } from "../../../../config/appConstants";
import { MessageBox } from "../../../sharedComponent/messageBox";
import { emailValidation } from "../../../../services/utility";
import { ApiUrls } from '../../../../services/api';
import Api from '../../../../services/api/serviceCall'
import * as actions from '../../../../actions/tmVoucher.Action';
import { bindActionCreators } from 'redux';

class TmVoucherPDFViewerComponent extends Component {
    constructor(props) {
        super(props);
        const routeParams = this.props?.history?.location?.state ?? undefined;
        this.state = {
            isFromDataEntry: routeParams?.isFromDataEntry ?? false,
            isProjectUnAssigned: routeParams?.isProjectUnAssigned ?? false,
            isTMVoucherAlreadySaved: routeParams?.isTMVoucherAlreadySaved ?? false,
            tmVoucherPdfBase64: "",
            isShowConfirmation: false,
            isShowLoader: false,
            tmVoucherConfirmMessage: Constants.TM_VOUCHER_SUBMIT_CONFIRMATION,
            isSubmitOnly: false,
            isShowSubmitAndEmailModal: false,
            tmVoucherEmail: this.emtpyEmail(),
            isSendButtonDisabled: false,
            isSubmitButtonDisabled: false,
            isSubmitAndEmailButtonDisabled: false,
            tmVoucherList: {},
            selectedTMVoucher: routeParams?.selectedTMVoucher,
        }
    }

    async componentDidMount() {
        const routeParams = this.props?.history?.location?.state ?? undefined;
        if (!routeParams) {
            this.props.history.push("/TimeCard");
            return;
        }
        await this.loadTMVoucherPdf();
        if (this.state.isFromDataEntry) {
            await this.loadSavedTMVoucher();
        }
    }

    async loadTMVoucherPdf() {
        const { selectedTMVoucher } = this.state;
        const url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_PF_AMT_M}?deviceId=${this.props.device.deviceId}&tmVoucherId=${selectedTMVoucher.id}`;
        try {
            const response = await Api.Get(url, this);
            if (response.success) {
                if (response.data) {
                    this.setState({ tmVoucherPdfBase64: response.data.attachmentContent });
                }
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        } catch (error) {
            MessageBox(error, Constants.ERROR);
        }
    }

    async loadSavedTMVoucher() {
        const { selectedTMVoucher, isTMVoucherAlreadySaved } = this.state;
        const url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_SLCT_TM_VCHR_DET_M}?deviceId=${this.props.device.deviceId}&projectId=${selectedTMVoucher.projectId}&taskCodeId=${selectedTMVoucher.taskCodeID}&tmVoucherId=${selectedTMVoucher.id}&fetchPdf=${true}`;

        try {
            const response = await Api.Get(url, this);
            if (response.success && response.data) {
                if (!isTMVoucherAlreadySaved) {
                    let tmVoucherAttachments = response.data.tmAttachments;
                    if (tmVoucherAttachments && tmVoucherAttachments?.length > 0) {
                        response.data.tmVoucherSignature = tmVoucherAttachments?.filter(a => a?.attachmentName === Constants.TM_VOUCHER_SIGNATURE_DISCRIMINATOR);
                    }
                }
                this.setState({ tmVoucherList: response.data });
            }
            else {
                MessageBox(response.message, Constants.ERROR);
            }
        } catch (error) {
            MessageBox(error, Constants.ERROR);
        }
    }

    emtpyEmail() {
        return {
            emailSubject: "",
            emailBody: "",
            sendToEmailAddress: [],
            sendToEmailAddressList: [],
            ccEmailAddress: [],
            ccEmailAddressList: []
        }
    }

    onClickSubmit(isSubmitOnly = false, isFromEmail = false) {
        if (this.state.isTMVoucherAlreadySaved && !isFromEmail) {
            this.setState({ isShowConfirmation: true, isSubmitOnly })
        } else {      
            this.setState({ isSendButtonDisabled: true, isSubmitButtonDisabled: true }, () => {
                this.submitTMVoucher(isSubmitOnly, this.state.tmVoucherEmail).catch(_ => this.setState({ isSendButtonDisabled: false, isSubmitButtonDisabled: false }));
            })
        }
    }

    goOrCloseConfirmation(isYesButtonClicked) {
        const { isSubmitOnly } = this.state;
        if (isYesButtonClicked) {
            if (!isSubmitOnly) {
                this.setState({ isShowSubmitAndEmailModal: true, isShowConfirmation: false, isSubmitAndEmailButtonDisabled:true });
            }
            else {
                this.setState({ isSubmitButtonDisabled: true }, () => {
                    this.submitTMVoucher(isSubmitOnly).catch(_ => this.setState({ isSubmitButtonDisabled: false }));
                });
            }
        } else {
            this.setState({ isShowConfirmation: false, isSubmitOnly: false, isSubmitAndEmailButtonDisabled:false, tmVoucherEmail: this.emtpyEmail() });
        }
    }

    onClickSubmitAndEmailBtn(isClose = false) {
        const { isTMVoucherAlreadySaved } = this.state;
        if (isTMVoucherAlreadySaved && !isClose) {
            this.setState({ isShowConfirmation: true });
        } else {
            this.setState({ isShowSubmitAndEmailModal: !isClose, isShowConfirmation: false, isSubmitOnly: false, isSubmitAndEmailButtonDisabled:!isClose, tmVoucherEmail: this.emtpyEmail() });
        }
    }

    onClickBackBtn() {
        this.props.history.goBack();
    }

    handleEmailChange(e, { name, value }) {
         let { tmVoucherEmail } = this.state;
            let addressList = tmVoucherEmail[name+"List"];
            let addresss = tmVoucherEmail[name];
         
        if(addressList && value && addressList.length > value.length )
        {
            addressList = value.map( v => { return { value: v.toLowerCase(), key: v.toLowerCase(), text: v.toLowerCase() }; });   
            addresss = value?.map(email => email.toLowerCase());
        }
        else
        {
            const enteredEmail = value[value.length - 1];
            if (!emailValidation(enteredEmail)) {
                MessageBox(Constants.PLEASE_ENTER_VALID_EMAIL, Constants.ERROR);
                return;
            }
            if (enteredEmail) {
                if (addressList.find(a => a.value === enteredEmail)) {
                    MessageBox(Constants.ENTER_EMAIL_ALREADY_SELECTED, Constants.ERROR);
                } else if (!addressList.find(a => a.value === enteredEmail)) {
                    addressList.push({ value: enteredEmail.toLowerCase(), key: enteredEmail.toLowerCase(), text: enteredEmail.toLowerCase() });
                    addresss = value?.map(email => email.toLowerCase());
                }
            }
        }        
            this.setState((prevState) => ({
                tmVoucherEmail: { ...prevState.tmVoucherEmail, [name]: [...addresss], [name+"List"]: [...addressList] }
            }));
    }

    submitTMVoucher(isSubmitOnly = false, emailObj = {}) {
        let { tmVoucherList, isTMVoucherAlreadySaved } = this.state;
        this.setState({ isShowLoader:true, isShowConfirmation: false });
            tmVoucherList.status = `${Constants.NEW_STATUS}`;
            tmVoucherList.submittedDate = new Date();
            tmVoucherList.syncedDateTime = new Date();
            tmVoucherList.tmEquipments = tmVoucherList.tmEquipments.filter(a => a.id !== 0);
            tmVoucherList.tmMaterials = tmVoucherList.tmMaterials.filter(a => a.id !== 0);
            tmVoucherList.tmMiscellaneous = tmVoucherList.tmMiscellaneous.filter(a => a.id !== 0);

            if (isTMVoucherAlreadySaved) {
                tmVoucherList.id = 0;
                tmVoucherList.tmEmployees.map(a => a.id = 0);
                tmVoucherList.tmEquipments.map(a => a.id = 0);
                tmVoucherList.tmMaterials.map(a => a.id = 0);
                tmVoucherList.tmAttachments.map(a => a.id = 0);
                tmVoucherList.tmMiscellaneous.map(a => a.id = 0);
                tmVoucherList.tmVersion += 1;
                tmVoucherList.submittedMode = `${Constants.MANUAL_SUBMITTED_MODE}`;
            }
            let tmVoucherReport = {
                tmVoucherList: [tmVoucherList],
                isFromSubmitAndEmail: !isSubmitOnly,
                ...emailObj
            };
            let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.SV_TM_VCHR_M}`;
            return new Promise((resolve, reject) => {
                Api.Post(url, tmVoucherReport, this).then((response) => {
                  this.setState({ isShowLoader: false });
                    if (response.success) {
                        this.props.selectedTMVoucherData("");
                        this.props.history.push("/TimeCard", { isOpenSelectTaskCode: true});
                        resolve(true);
                    } else {
                        MessageBox(response.message, Constants.ERROR);
                        reject(false);
                    }
                }).catch(_ => {
                    this.setState({ isShowLoader: false });
                    reject(false);
                });
           });
    }

    handleInputChange(event, inputName) {
        let { tmVoucherEmail } = this.state;
        switch (inputName) {
            case Constants.TM_VOUCHER_SUBJECT_TEXT:
                tmVoucherEmail.emailSubject = event;
                break;
            case Constants.TM_VOUCHER_BODY_TEXT:
                tmVoucherEmail.emailBody = event;
                break;
            default:
                break;
        }
        this.setState({ tmVoucherEmail });
    }
    render() {
        const { tmVoucherPdfBase64, isFromDataEntry, isProjectUnAssigned, isShowConfirmation, tmVoucherConfirmMessage, isShowSubmitAndEmailModal, tmVoucherEmail, isSendButtonDisabled, isSubmitButtonDisabled, isSubmitAndEmailButtonDisabled, isShowLoader} = this.state;
        return (
            <TMVoucherPDFViewer
                {...{
                    tmVoucherPdf: {
                        isFromDataEntry,
                        isProjectUnAssigned,
                        tmVoucherPdfBase64,
                        isShowConfirmation,
                        tmVoucherConfirmMessage,
                        isShowLoader,
                        isShowSubmitAndEmailModal,
                        tmVoucherEmail,
                        isSendButtonDisabled,
                        isSubmitButtonDisabled,
                        isSubmitAndEmailButtonDisabled
                    }
                }}
                onClickSubmit={this.onClickSubmit.bind(this)}
                onClickBackBtn={this.onClickBackBtn.bind(this)}
                goOrCloseConfirmation={this.goOrCloseConfirmation.bind(this)}
                onClickSubmitAndEmailBtn={this.onClickSubmitAndEmailBtn.bind(this)}
                handleEmailChange={this.handleEmailChange.bind(this)}  
                handleInputChange={this.handleInputChange.bind(this)}  
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TmVoucherPDFViewerComponent);

TmVoucherPDFViewerComponent.displayName = "TmVoucherPDFViewerComponent";